import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
const ControlAdd = React.memo((props) => (<Icon component={() => (<svg focusable="false" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8 2a1 1 0 0 1 1 1v4h4a1 1 0 1 1 0 2H9v4a1 1 0 1 1-2 0V9H3a1 1 0 1 1 0-2h4V3a1 1 0 0 1 1-1z"/>
      </svg>)} {...props}/>));
export default ControlAdd;
